<template>
  <ProductsTable></ProductsTable>
</template>

<script type="text/javascript">
import ProductsTable from "../ProductsTable/ProductsTable.vue";
import {mapActions} from "vuex";

export default {
    name: "ProductsList",
    components: {ProductsTable},
    methods: {
        ...mapActions("getProducts", ["getProdutsHeadersTableRequest"]),
    },
    mounted() {
        this.updateLanguage(this.getCurrentLanguage);
        this.getProdutsHeadersTableRequest();
    },
}
</script>